import { render, staticRenderFns } from "./Carousel.vue?vue&type=template&id=4017ff8c&scoped=true&"
import script from "./Carousel.vue?vue&type=script&lang=js&"
export * from "./Carousel.vue?vue&type=script&lang=js&"
import style0 from "./Carousel.vue?vue&type=style&index=0&id=4017ff8c&lang=scss&scoped=true&"
import style1 from "./Carousel.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4017ff8c",
  null
  
)

export default component.exports